import LzSAppBasics from '@lz-app/AppBasics';
import { DEV_API_BASE_URI, DEV_APP_BASE_URI } from '.settings/DevSettings';

// Set the global app variables
const appBasicsInit = LzSAppBasics.init({
    app_code: 'lzGwpWCards',
    app_name: 'Weighing Cards for GWP',
    app_base_url: typeof (window as any).LZ_APP_BASE_URI !== 'undefined' && (window as any).LZ_APP_BASE_URI !== '' ? (window as any).LZ_APP_BASE_URI : DEV_APP_BASE_URI,
    api_base_url: typeof (window as any).LZ_API_ENDPOINT_URI !== 'undefined' && (window as any).LZ_API_ENDPOINT_URI !== '' ? (window as any).LZ_API_ENDPOINT_URI : DEV_API_BASE_URI,
    debug_mode_enabled: true,
});

export default appBasicsInit;
